module.exports = __webpack_public_path__ + "static/media/branding.088d1406.png";